import lrOldTable from './_src/lrOldTable.vue'

lrOldTable.install = function(Vue) {
  Vue.component(lrOldTable.name, lrOldTable)
}

export default lrOldTable